/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Ujjwal Singh >

*/

export default {
  contained: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    backgroundColor: '#FFFFFF',
  }
};
